<div id="cmx-footer-action-buttons" [class]="'buttons-footer bottom-V' + navVersion">
  <div [class]="'buttons-footer bottom-V' + navVersion">
    <ng-content></ng-content>
  </div>
</div>
